import { c as _c } from "react/compiler-runtime";
import { useHistoryEntity } from '../history-utils/entity.ts';
export const EmptyState = t0 => {
  const $ = _c(9);
  const {
    filtered
  } = t0;
  const t1 = useHistoryEntity();
  let t2;
  if ($[0] !== t1.name) {
    t2 = t1.name.toLowerCase();
    $[0] = t1.name;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const entity = t2;
  const t3 = filtered ? "No history matches your filters" : "No history yet";
  let t4;
  if ($[2] !== t3) {
    t4 = <div className="font-medium">{t3}</div>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = filtered ? "Try changing the category, person, or search term." : `Changes made to this ${entity} will appear here.`;
  let t6;
  if ($[4] !== t5) {
    t6 = <p className="max-w-md text-sm text-muted-foreground">{t5}</p>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4 || $[7] !== t6) {
    t7 = <div className="flex min-h-48 flex-col items-center justify-center gap-1 px-4 text-center" data-sentry-component="EmptyState" data-sentry-source-file="history-empty-state.tsx">{t4}{t6}</div>;
    $[6] = t4;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};